window.bundleDataA = {
"Aaden-boy": {
displayName: "Aaden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aaden Personalized Coloring Experience",
variantId: "49279554519277",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aaden.png?v=1772145038",
price: "$14.99",
preorder: true
},
{
title: "Aaden Dragon Holographic Sticker",
variantId: "49929570156781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aaden_holographic_sticker.png?v=1779221265",
price: "$4.99",
preorder: false
},
{
title: "Aaden Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Aadhya-girl": {
displayName: "Aadhya",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aadhya Personalized Coloring Experience",
variantId: "49272652202221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aadhya_final_cover.png?v=1773592234",
price: "$14.99",
preorder: true
},
{
title: "Aadhya Unicorn Holographic Sticker",
variantId: "49933781336301",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aadhya_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Aadhya Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Aaliyah-girl": {
displayName: "Aaliyah",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aaliyah Personalized Coloring Experience",
variantId: "49265164255469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aaliyah_final_cover.png?v=1773592232",
price: "$14.99",
preorder: true
},
{
title: "Aaliyah Unicorn Holographic Sticker",
variantId: "49933781369069",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aaliyah_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Aaliyah Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Aarna-girl": {
displayName: "Aarna",
gender: "girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aarna Personalized Coloring Experience",
variantId: "49265158455533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aarna_final_cover.png?v=1773592234",
price: "$14.99",
preorder: true
},
{
title: "Aarna Unicorn Holographic Sticker",
variantId: "49933781401837",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aarna_holographic_sticker.png?v=1779221264",
price: "$4.99",
preorder: false
},
{
title: "Aarna Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Aaron-boy": {
displayName: "Aaron",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aaron Personalized Coloring Experience",
variantId: "49279554584813",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aaron_updated.png?v=1772144744",
price: "$14.99",
preorder: true
},
{
title: "Aaron Dragon Holographic Sticker",
variantId: "49933780156653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aaron_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Aaron Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Abby-girl": {
displayName: "Abby",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Abby Personalized Coloring Experience",
variantId: "49265026236653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Abby_final_cover.png?v=1773592233",
price: "$14.99",
preorder: true
},
{
title: "Abby Unicorn Holographic Sticker",
variantId: "49933781598445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Abby_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Abby Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Abel-boy": {
displayName: "Abel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Abel Personalized Coloring Experience",
variantId: "49279554683117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Abel_final_cover.png?v=1772152468",
price: "$14.99",
preorder: true
},
{
title: "Abel Dragon Holographic Sticker",
variantId: "49933780123885",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Abel_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Abel Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Abigail-girl": {
displayName: "Abigail",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Abigail Personalized Coloring Experience",
variantId: "49265153474797",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Abigail_final_cover.png?v=1773592234",
price: "$14.99",
preorder: true
},
{
title: "Abigail Unicorn Holographic Sticker",
variantId: "49941365096685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Abigail_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Abigail Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Abraham-boy": {
displayName: "Abraham",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Abraham Personalized Coloring Experience",
variantId: "49279554814189",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Abraham_final_cover.png?v=1772152468",
price: "$14.99",
preorder: true
},
{
title: "Abraham Dragon Holographic Sticker",
variantId: "49933780058349",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Abrahamholographicsticker.png?v=1779221569",
price: "$4.99",
preorder: false
},
{
title: "Abraham Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ada-girl": {
displayName: "Ada",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ada Personalized Coloring Experience",
variantId: "49945826001133",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adafinalcover.png?v=1778361600",
price: "$14.99",
preorder: true
},
{
title: "Ada Unicorn Holographic Sticker",
variantId: "49945824854253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ada_holographic_sticker.png?v=1779337436",
price: "$4.99",
preorder: false
},
{
title: "Ada Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Adam-boy": {
displayName: "Adam",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Adam Personalized Coloring Experience",
variantId: "49279554879725",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adam_final_cover.png?v=1772152466",
price: "$14.99",
preorder: true
},
{
title: "Adam Dragon Holographic Sticker",
variantId: "49933780025581",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adam_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Adam Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Addison-girl": {
displayName: "Addison",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Addison Personalized Coloring Experience",
variantId: "49265015914733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Addison_final_cover.png?v=1773592234",
price: "$14.99",
preorder: true
},
{
title: "Addison Unicorn Holographic Sticker",
variantId: "49933781663981",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Addison_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Addison Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Adelaide-girl": {
displayName: "Adelaide",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Adelaide Personalized Coloring Experience",
variantId: "49971408601325",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adelaide_final_cover.png?v=1777863212",
price: "$14.99",
preorder: true
},
{
title: "Adelaide Unicorn Holographic Sticker",
variantId: "49945844646125",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adelaideholographicsticker.png?v=1779337531",
price: "$4.99",
preorder: false
},
{
title: "Adelaide Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Adeline-girl": {
displayName: "Adeline",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Adeline Personalized Coloring Experience",
variantId: "49265011654893",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adeline_final_cover.png?v=1773592234",
price: "$14.99",
preorder: true
},
{
title: "Adeline Unicorn Holographic Sticker",
variantId: "49933781696749",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adelineholographicsticker.png?v=1779221667",
price: "$4.99",
preorder: false
},
{
title: "Adeline Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Adrian-boy": {
displayName: "Adrian",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Adrian Personalized Coloring Experience",
variantId: "49279554945261",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adrian_final_cover.png?v=1772152467",
price: "$14.99",
preorder: true
},
{
title: "Adrian Dragon Holographic Sticker",
variantId: "49933779992813",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adrianholographicsticker.png?v=1779221700",
price: "$4.99",
preorder: false
},
{
title: "Adrian Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Adriel-boy": {
displayName: "Adriel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Adriel Personalized Coloring Experience",
variantId: "49279555076333",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adriel_final_cover.png?v=1771691712",
price: "$14.99",
preorder: true
},
{
title: "Adriel Dragon Holographic Sticker",
variantId: "49933779960045",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adriel_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Adriel Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Adrienne-girl": {
displayName: "Adrienne",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Adrienne Personalized Coloring Experience",
variantId: "49402707542253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ADRIENNEFINALCOVER.png?v=1771819866",
price: "$14.99",
preorder: true
},
{
title: "Adrienne Unicorn Holographic Sticker",
variantId: "49933768098029",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adrienne_holographic_sticker.png?v=1779221262",
price: "$4.99",
preorder: false
},
{
title: "Adrienne Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Aiden-boy": {
displayName: "Aiden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aiden Personalized Coloring Experience",
variantId: "49279555764461",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aiden_final_cover.png?v=1772152467",
price: "$14.99",
preorder: true
},
{
title: "Aiden Dragon Holographic Sticker",
variantId: "49933779927277",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aiden_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Aiden Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Alan-boy": {
displayName: "Alan",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alan Personalized Coloring Experience",
variantId: "49279555895533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alan_final_cover.png?v=1772152468",
price: "$14.99",
preorder: true
},
{
title: "Alan Dragon Holographic Sticker",
variantId: "49933779894509",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alanholographicsticker.png?v=1779221820",
price: "$4.99",
preorder: false
},
{
title: "Alan Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Alecia-girl": {
displayName: "Alecia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alecia Personalized Coloring Experience",
variantId: "49402715177197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ALECIAFINALCOVER.png?v=1771820184",
price: "$14.99",
preorder: true
},
{
title: "Alecia Unicorn Holographic Sticker",
variantId: "49933767934189",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alecia_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Alecia Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Alejandro-boy": {
displayName: "Alejandro",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alejandro Personalized Coloring Experience",
variantId: "49279555961069",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alejandro_final_cover.png?v=1772162972",
price: "$14.99",
preorder: true
},
{
title: "Alejandro Dragon Holographic Sticker",
variantId: "49933779861741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alejandroholographicsticker.png?v=1779221875",
price: "$4.99",
preorder: false
},
{
title: "Alejandro Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Alex-boy": {
displayName: "Alex",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alex Personalized Coloring Experience",
variantId: "49279556026605",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alex_final_cover.png?v=1772152468",
price: "$14.99",
preorder: true
},
{
title: "Alex Dragon Holographic Sticker",
variantId: "49933779828973",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alex_holographic_sticker.png?v=1779221263",
price: "$4.99",
preorder: false
},
{
title: "Alex Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Alexa-girl": {
displayName: "Alexa",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alexa Personalized Coloring Experience",
variantId: "49272676778221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alexa_final_cover.png?v=1773684207",
price: "$14.99",
preorder: true
},
{
title: "Alexa Unicorn Holographic Sticker",
variantId: "49933781303533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alexa_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Alexa Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Alexander-boy": {
displayName: "Alexander",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alexander Personalized Coloring Experience",
variantId: "49279556157677",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alexander_final_cover.png?v=1772152468",
price: "$14.99",
preorder: true
},
{
title: "Alexander Dragon Holographic Sticker",
variantId: "49933779796205",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alexander_holographic_sticker.png?v=1779221265",
price: "$4.99",
preorder: false
},
{
title: "Alexander Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Alexandra-girl": {
displayName: "Alexandra",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alexandra Personalized Coloring Experience",
variantId: "49272687329517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alexandra_final_cover.png?v=1773684207",
price: "$14.99",
preorder: true
},
{
title: "Alexandra Unicorn Holographic Sticker",
variantId: "49933781270765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alexandra_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Alexandra Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Alice-girl": {
displayName: "Alice",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alice Personalized Coloring Experience",
variantId: "49264942842093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alice_final_cover.png?v=1773684207",
price: "$14.99",
preorder: true
},
{
title: "Alice Unicorn Holographic Sticker",
variantId: "49933781795053",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alice_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Alice Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Alina-girl": {
displayName: "Alina",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alina Personalized Coloring Experience",
variantId: "49279556255981",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alina_final_cover.png?v=1773684207",
price: "$14.99",
preorder: true
},
{
title: "Alina Unicorn Holographic Sticker",
variantId: "49933779763437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alina_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Alina Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Aliyah-girl": {
displayName: "Aliyah",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aliyah Personalized Coloring Experience",
variantId: "49279556288749",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aliyah_final_cover.png?v=1773684207",
price: "$14.99",
preorder: true
},
{
title: "Aliyah Unicorn Holographic Sticker",
variantId: "49933779730669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aliyah_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Aliyah Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Allison-girl": {
displayName: "Allison",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Allison Personalized Coloring Experience",
variantId: "49279556419821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Allison_final_cover.png?v=1772851513",
price: "$14.99",
preorder: true
},
{
title: "Allison Unicorn Holographic Sticker",
variantId: "49933779697901",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Allison_holographic_sticker.png?v=1779221263",
price: "$4.99",
preorder: false
},
{
title: "Allison Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Allyson-girl": {
displayName: "Allyson",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Allyson Personalized Coloring Experience",
variantId: "49754050724077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Allyson_final_cover.png?v=1775322362",
price: "$14.99",
preorder: true
},
{
title: "Allyson Unicorn Holographic Sticker",
variantId: "49933753254125",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Allyson_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Allyson Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Alyssa-girl": {
displayName: "Alyssa",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alyssa Personalized Coloring Experience",
variantId: "49471693488365",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alyssa_final_cover.png?v=1772908492",
price: "$14.99",
preorder: true
},
{
title: "Alyssa Unicorn Holographic Sticker",
variantId: "49933759545581",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alyssa_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Alyssa Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Amara-girl": {
displayName: "Amara",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Amara Personalized Coloring Experience",
variantId: "49929707815149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amara_final_cover.png?v=1777863212",
price: "$14.99",
preorder: true
},
{
title: "Amara Unicorn Holographic Sticker",
variantId: "49933745455341",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amara_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Amara Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Amaya-girl": {
displayName: "Amaya",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Amaya Personalized Coloring Experience",
variantId: "49471948161261",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amaya_final_cover.png?v=1772908494",
price: "$14.99",
preorder: true
},
{
title: "Amaya Unicorn Holographic Sticker",
variantId: "49933759316205",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amaya_holographic_sticker.png?v=1779221262",
price: "$4.99",
preorder: false
},
{
title: "Amaya Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ambrose-boy": {
displayName: "Ambrose",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ambrose Personalized Coloring Experience",
variantId: "49731873177837",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ambrose_final_cover.png?v=1774739906",
price: "$14.99",
preorder: true
},
{
title: "Ambrose Dragon Holographic Sticker",
variantId: "49933753483501",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ambrose_holographic_sticker.png?v=1779221264",
price: "$4.99",
preorder: false
},
{
title: "Ambrose Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Amelia-girl": {
displayName: "Amelia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Amelia Personalized Coloring Experience",
variantId: "49279556485357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amelia_final_cover.png?v=1773684205",
price: "$14.99",
preorder: true
},
{
title: "Amelia Unicorn Holographic Sticker",
variantId: "49933779665133",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amelia_holographic_sticker_47eff3b1-4300-4131-8db7-c37b60e66c9b.png?v=1779221268",
price: "$4.99",
preorder: false
},
{
title: "Amelia Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Amy-girl": {
displayName: "Amy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Amy Personalized Coloring Experience",
variantId: "49279556681965",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amy_final_cover.png?v=1773684206",
price: "$14.99",
preorder: true
},
{
title: "Amy Unicorn Holographic Sticker",
variantId: "49933779632365",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amy_holographic_sticker_91ea7966-4c3b-4319-a46b-e5c60e13bf6e.png?v=1779221265",
price: "$4.99",
preorder: false
},
{
title: "Amy Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ana-girl": {
displayName: "Ana",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ana Personalized Coloring Experience",
variantId: "49279556747501",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ana_final_cover.png?v=1773684206",
price: "$14.99",
preorder: true
},
{
title: "Ana Unicorn Holographic Sticker",
variantId: "49933779599597",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ana_holographic_sticker_074c4c85-e11e-4346-b97d-1919393eb13e.png?v=1779221262",
price: "$4.99",
preorder: false
},
{
title: "Ana Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Anastasia-girl": {
displayName: "Anastasia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Anastasia Personalized Coloring Experience",
variantId: "49272704139501",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Final_Anastasia_cover.png?v=1770589608",
price: "$14.99",
preorder: true
},
{
title: "Anastasia Unicorn Holographic Sticker",
variantId: "49933781205229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Anastasia_holographic_sticker.png?v=1779221264",
price: "$4.99",
preorder: false
},
{
title: "Anastasia Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Andrea-girl": {
displayName: "Andrea",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Andrea Personalized Coloring Experience",
variantId: "49279556878573",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Andrea_final_cover.png?v=1772851511",
price: "$14.99",
preorder: true
},
{
title: "Andrea Unicorn Holographic Sticker",
variantId: "49933779566829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Andrea_holographic_sticker_19553f98-81d4-472a-9e5e-987e62565fae.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Andrea Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Andres-boy": {
displayName: "Andres",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Andres Personalized Coloring Experience",
variantId: "49279556944109",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Andres_final_cover.png?v=1772152467",
price: "$14.99",
preorder: true
},
{
title: "Andres Dragon Holographic Sticker",
variantId: "49933779534061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Andres_holographic_sticker.png?v=1779221269",
price: "$4.99",
preorder: false
},
{
title: "Andres Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Andrew-boy": {
displayName: "Andrew",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Andrew Personalized Coloring Experience",
variantId: "49279557009645",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Andrew_final_cover.png?v=1772152468",
price: "$14.99",
preorder: true
},
{
title: "Andrew Dragon Holographic Sticker",
variantId: "49933779501293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Andrew_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Andrew Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Andy-boy": {
displayName: "Andy",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Andy Personalized Coloring Experience",
variantId: "49279557140717",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Andy_final_cover.png?v=1772152467",
price: "$14.99",
preorder: true
},
{
title: "Andy Dragon Holographic Sticker",
variantId: "49933779468525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Andy_holographic_sticker_282a87dd-3a3a-4d51-919d-0ed3f7e079e3.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Andy Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Angel-boy": {
displayName: "Angel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Angel Personalized Coloring Experience",
variantId: "49279557206253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Angel_final_cover.png?v=1772152468",
price: "$14.99",
preorder: true
},
{
title: "Angel Dragon Holographic Sticker",
variantId: "49933779435757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Angel_holographic_sticker.png?v=1779221265",
price: "$4.99",
preorder: false
},
{
title: "Angel Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Angela-girl": {
displayName: "Angela",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Angela Personalized Coloring Experience",
variantId: "49279554945261",
image: "https://lkbunting.com/cdn/shop/files/Angela_final_cover.png?v=1772851513&width=600",
price: "$14.99",
preorder: true
},
{
title: "Angela Unicorn Holographic Sticker",
variantId: "49933779992813",
image: "https://lkbunting.com/cdn/shop/files/Angela_holographic_sticker_73f80e85-0780-4f21-b98e-bcbafdc6edd1.png?v=1779221265&width=600",
price: "$4.99",
preorder: false
},
{
title: "Angela Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,"Angelina-girl": {
displayName: "Angelina",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Angelina Personalized Coloring Experience",
variantId: "49279557337325",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Angelina_final_cover.png?v=1772851515",
price: "$14.99",
preorder: true
},
{
title: "Angelina Unicorn Holographic Sticker",
variantId: "49933779370221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Angelina_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Angelina Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Anna-girl": {
displayName: "Anna",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Anna Personalized Coloring Experience",
variantId: "49471951405293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Anna_final_cover.png?v=1772908493",
price: "$14.99",
preorder: true
},
{
title: "Anna Unicorn Holographic Sticker",
variantId: "49933759283437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Anna_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Anna Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Anthony-boy": {
displayName: "Anthony",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Anthony Personalized Coloring Experience",
variantId: "49279557435629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Anthony_final_cover.png?v=1772152467",
price: "$14.99",
preorder: true
},
{
title: "Anthony Dragon Holographic Sticker",
variantId: "49933779337453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Anthony_holographic_sticker.png?v=1779221263",
price: "$4.99",
preorder: false
},
{
title: "Anthony Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Antonio-boy": {
displayName: "Antonio",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Antonio Personalized Coloring Experience",
variantId: "49339359035629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Antonio_final_cover.png?v=1772152468",
price: "$14.99",
preorder: true
},
{
title: "Antonio Dragon Holographic Sticker",
variantId: "49933772357869",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/antonio_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Antonio Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Anvi-girl": {
displayName: "Anvi",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Anvi Personalized Coloring Experience",
variantId: "49279557533933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Anvi_final_cover.png?v=1772851512",
price: "$14.99",
preorder: true
},
{
title: "Anvi Unicorn Holographic Sticker",
variantId: "49933779304685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Anvi_holographic_sticker.png?v=1779221265",
price: "$4.99",
preorder: false
},
{
title: "Anvi Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Arabella-girl": {
displayName: "Arabella",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Arabella Personalized Coloring Experience",
variantId: "49801323905261",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Arabella_final_cover.png?v=1775415295",
price: "$14.99",
preorder: true
},
{
title: "Arabella Unicorn Holographic Sticker",
variantId: "49933752664301",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Arabella_holographic_sticker_1de93020-a78e-4da4-b0f6-62a67383d5e2.png?v=1779221265",
price: "$4.99",
preorder: false
},
{
title: "Arabella Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Archer-boy": {
displayName: "Archer",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Archer Personalized Coloring Experience",
variantId: "49274709868781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Archer_final_cover.png?v=1772243800",
price: "$14.99",
preorder: true
},
{
title: "Archer Dragon Holographic Sticker",
variantId: "49933780484333",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Archer_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Archer Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Archie-boy": {
displayName: "Archie",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Archie Personalized Coloring Experience",
variantId: "49929625501933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Archie_final_cover.png?v=1777856290",
price: "$14.99",
preorder: true
},
{
title: "Archie Dragon Holographic Sticker",
variantId: "49933746143469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Archieholographicsticker.png?v=1779222716",
price: "$4.99",
preorder: false
},
{
title: "Archie Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ari-boy": {
displayName: "Ari",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ari Personalized Coloring Experience",
variantId: "49709364969709",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ari_final_cover.png?v=1774104747",
price: "$14.99",
preorder: true
},
{
title: "Ari Dragon Holographic Sticker",
variantId: "49933753909485",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ari_holographic_sticker.png?v=1779221265",
price: "$4.99",
preorder: false
},
{
title: "Ari Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Aria-girl": {
displayName: "Aria",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aria Personalized Coloring Experience",
variantId: "49279557632237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aria_final_cover.png?v=1773684207",
price: "$14.99",
preorder: true
},
{
title: "Aria Unicorn Holographic Sticker",
variantId: "49933779239149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aria_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Aria Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ariana-girl": {
displayName: "Ariana",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ariana Personalized Coloring Experience",
variantId: "49471786746093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ariana_final_cover.png?v=1772908493",
price: "$14.99",
preorder: true
},
{
title: "Ariana Unicorn Holographic Sticker",
variantId: "49933759381741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ariana_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Ariana Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Arianna-girl": {
displayName: "Arianna",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Arianna Personalized Coloring Experience",
variantId: "49471724224749",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ariannafinalfinalcover.png?v=1773325379",
price: "$14.99",
preorder: true
},
{
title: "Arianna Unicorn Holographic Sticker",
variantId: "49933759512813",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Arianna_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Arianna Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ariel-girl": {
displayName: "Ariel",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ariel Personalized Coloring Experience",
variantId: "49272696701165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ariel_girl_and_unicorn.png?v=1773684207",
price: "$14.99",
preorder: true
},
{
title: "Ariel Unicorn Holographic Sticker",
variantId: "49933781237997",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ariel_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Ariel Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Arlo-boy": {
displayName: "Arlo",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Arlo Personalized Coloring Experience",
variantId: "49299068453101",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Arlo_final_cover.png?v=1772753296",
price: "$14.99",
preorder: true
},
{
title: "Arlo Dragon Holographic Sticker",
variantId: "49933772685549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Arlo_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Arlo Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Arya-girl": {
displayName: "Arya",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Arya Personalized Coloring Experience",
variantId: "49279557763309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Arya_final_cover.png?v=1772851513",
price: "$14.99",
preorder: true
},
{
title: "Arya Unicorn Holographic Sticker",
variantId: "49933779140845",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Arya_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Arya Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Asher-boy": {
displayName: "Asher",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Asher Personalized Coloring Experience",
variantId: "49279557828845",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Asher_final_cover.png?v=1772243801",
price: "$14.99",
preorder: true
},
{
title: "Asher Dragon Holographic Sticker",
variantId: "49933779108077",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Asherholographicsticker.png?v=1779240106",
price: "$4.99",
preorder: false
},
{
title: "Asher Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ashley-girl": {
displayName: "Ashley",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ashley Personalized Coloring Experience",
variantId: "49279557894381",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ashley_final_cover.png?v=1772851512",
price: "$14.99",
preorder: true
},
{
title: "Ashley Unicorn Holographic Sticker",
variantId: "49933779075309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ashley_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Ashley Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ashlie-girl": {
displayName: "Ashlie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ashlie Personalized Coloring Experience",
variantId: "49279558025453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ashlie_final_cover.png?v=1772851513",
price: "$14.99",
preorder: true
},
{
title: "Ashlie Unicorn Holographic Sticker",
variantId: "49933779042541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ashlie_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Ashlie Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Astrid-girl": {
displayName: "Astrid",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Astrid Personalized Coloring Experience",
variantId: "49945798672621",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Astridfinalcover.png?v=1778359394",
price: "$14.99",
preorder: true
},
{
title: "Astrid Unicorn Holographic Sticker",
variantId: "49945783501037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Astridholographicsticker.png?v=1779337632",
price: "$4.99",
preorder: false
},
{
title: "Astrid Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Athena-girl": {
displayName: "Athena",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Athena Personalized Coloring Experience",
variantId: "49479246446829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Athena_final_cover.png?v=1772930029",
price: "$14.99",
preorder: true
},
{
title: "Athena Unicorn Holographic Sticker",
variantId: "49933758464237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Athenaholographicsticker.png?v=1779240728",
price: "$4.99",
preorder: false
},
{
title: "Athena Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Aubree-girl": {
displayName: "Aubree",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aubree Personalized Coloring Experience",
variantId: "49402683195629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/AUBREEFINALCOVER.png?v=1771818922",
price: "$14.99",
preorder: true
},
{
title: "Aubree Unicorn Holographic Sticker",
variantId: "49801120973037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aubree_holographic_sticker.png?v=1779221265",
price: "$4.99",
preorder: false
},
{
title: "Aubree Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Aubrey-girl": {
displayName: "Aubrey",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aubrey Personalized Coloring Experience",
variantId: "49479289045229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aubrey_final_cover.png?v=1772930028",
price: "$14.99",
preorder: true
},
{
title: "Aubrey Unicorn Holographic Sticker",
variantId: "49933758333165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aubrey_holographic_sticker.png?v=1779221265",
price: "$4.99",
preorder: false
},
{
title: "Aubrey Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Audrey-girl": {
displayName: "Audrey",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Audrey Personalized Coloring Experience",
variantId: "49279558156525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Audrey_final_cover.png?v=1773684207",
price: "$14.99",
preorder: true
},
{
title: "Audrey Unicorn Holographic Sticker",
variantId: "49933778977005",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Audrey_holographic_sticker.png?v=1779221264",
price: "$4.99",
preorder: false
},
{
title: "Audrey Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Audriana-girl": {
displayName: "Audriana",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Audriana Personalized Coloring Experience",
variantId: "49754190676205",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Audriana_final_cover.png?v=1775322363",
price: "$14.99",
preorder: true
},
{
title: "Audriana Unicorn Holographic Sticker",
variantId: "49933753221357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Audriana_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Audriana Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"August-boy": {
displayName: "August",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "August Personalized Coloring Experience",
variantId: "49299077726445",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/August_final_cover.png?v=1772753295",
price: "$14.99",
preorder: true
},
{
title: "August Dragon Holographic Sticker",
variantId: "49933772554477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Augustholographicsticker.png?v=1779241718",
price: "$4.99",
preorder: false
},
{
title: "August Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Aurelia-girl": {
displayName: "Aurelia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aurelia Personalized Coloring Experience",
variantId: "49299060850925",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aurelia_final_cover.png?v=1773766537",
price: "$14.99",
preorder: true
},
{
title: "Aurelia Unicorn Holographic Sticker",
variantId: "49933772751085",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aurelia_holographic_sticker.png?v=1779221265",
price: "$4.99",
preorder: false
},
{
title: "Aurelia Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Aurelius-boy": {
displayName: "Aurelius",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aurelius Personalized Coloring Experience",
variantId: "49709384073453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aurelius_final_cover.png?v=1774104746",
price: "$14.99",
preorder: true
},
{
title: "Aurelius Dragon Holographic Sticker",
variantId: "49933753811181",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aurelius_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Aurelius Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Aurora-girl": {
displayName: "Aurora",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aurora Personalized Coloring Experience",
variantId: "49279558222061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aurora_final_cover.png?v=1772851512",
price: "$14.99",
preorder: true
},
{
title: "Aurora Unicorn Holographic Sticker",
variantId: "49933778944237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aurora_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Aurora Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Austin-boy": {
displayName: "Austin",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Austin Personalized Coloring Experience",
variantId: "49339376697581",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Austin_final_cover.png?v=1772243800",
price: "$14.99",
preorder: true
},
{
title: "Austin Dragon Holographic Sticker",
variantId: "49933772292333",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Austinholographicsticker.png?v=1779242402",
price: "$4.99",
preorder: false
},
{
title: "Austin Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Autumn-girl": {
displayName: "Autumn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Autumn Personalized Coloring Experience",
variantId: "49279558353133",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Autumn_final_cover.png?v=1772851512",
price: "$14.99",
preorder: true
},
{
title: "Autumn Unicorn Holographic Sticker",
variantId: "49933778911469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Autumn_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Autumn Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ava-girl": {
displayName: "Ava",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ava Personalized Coloring Experience",
variantId: "49272705351917",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ava_final_cover.png?v=1773684207",
price: "$14.99",
preorder: true
},
{
title: "Ava Unicorn Holographic Sticker",
variantId: "49933781172461",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ava_holographic_sticker.png?v=1779221267",
price: "$4.99",
preorder: false
},
{
title: "Ava Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Avery-girl": {
displayName: "Avery",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Avery Personalized Coloring Experience",
variantId: "49279558451437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Avery_final_cover.png?v=1773684207",
price: "$14.99",
preorder: true
},
{
title: "Avery Unicorn Holographic Sticker",
variantId: "49933778813165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Avery_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Avery Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Axel-boy": {
displayName: "Axel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Axel Personalized Coloring Experience",
variantId: "49339385118957",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Axel_final_cover.png?v=1772243801",
price: "$14.99",
preorder: true
},
{
title: "Axel Dragon Holographic Sticker",
variantId: "49933772259565",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Axel_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Axel Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Ayden-boy": {
displayName: "Ayden",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ayden Personalized Coloring Experience",
variantId: "49279558516973",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ayden_final_cover.png?v=1772243801",
price: "$14.99",
preorder: true
},
{
title: "Ayden Dragon Holographic Sticker",
variantId: "49933778747629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ayden_holographic_sticker.png?v=1779221266",
price: "$4.99",
preorder: false
},
{
title: "Ayden Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Anne-girl": {
displayName: "Anne",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Anne Personalized Coloring Experience",
variantId: "50042244858093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Anne_final_cover_de67ba26-1e7c-4d71-aa45-6aed04a8d236.png?v=1780107449",
price: "$14.99",
preorder: true
},
{
title: "Anne Unicorn Holographic Sticker",
variantId: "50042177487085",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Anne_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Anne Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Ann-girl": {
displayName: "Ann",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ann Personalized Coloring Experience",
variantId: "50042283360493",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ann_final_cover_c6d42418-ce5f-467b-aeb5-de4a366a0a04.png?v=1780107460",
price: "$14.99",
preorder: true
},
{
title: "Ann Unicorn Holographic Sticker",
variantId: "50042178601197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ann_holographic_sticker.png?v=1780099048",
price: "$4.99",
preorder: false
},
{
title: "Ann Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Amber-girl": {
displayName: "Amber",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Amber Personalized Coloring Experience",
variantId: "50042416693485",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amber_final_cover.png?v=1780107487",
price: "$14.99",
preorder: true
},
{
title: "Amber Unicorn Holographic Sticker",
variantId: "50042186170605",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amber_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Amber Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Amanda-girl": {
displayName: "Amanda",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Amanda Personalized Coloring Experience",
variantId: "50042452803821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amanda_final_cover.png?v=1780107502",
price: "$14.99",
preorder: true
},
{
title: "Amanda Unicorn Holographic Sticker",
variantId: "50042186858733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amanda_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Amanda Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Ayla-girl": {
displayName: "Ayla",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ayla Personalized Coloring Experience",
variantId: "50056831795437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ayla_final_cover.png?v=1780209146",
price: "$14.99",
preorder: true
},
{
title: "Ayla Unicorn Holographic Sticker",
variantId: "50057005203693",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ayla_holographic_sticker.png?v=1780206654",
price: "$4.99",
preorder: false
},
{
title: "Ayla Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Alaia-girl": {
displayName: "Alaia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alaia Personalized Coloring Experience",
variantId: "50078178017517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alaia_final_cover.png?v=1780809444",
price: "$14.99",
preorder: true
},
{
title: "Alaia Unicorn Holographic Sticker",
variantId: "50077626990829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alaia_sticker_website.png?v=1780804206",
price: "$4.99",
preorder: false
},
{
title: "Alaia Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Adalynn-girl": {
displayName: "Adalynn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Adalynn Personalized Coloring Experience",
variantId: "50078196105453",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adalynn_final_cover.png?v=1780809444",
price: "$14.99",
preorder: true
},
{
title: "Adalynn Unicorn Holographic Sticker",
variantId: "50077627482349",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adalynn_sticker_website.png?v=1780804206",
price: "$4.99",
preorder: false
},
{
title: "Adalynn Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Amir-boy": {
displayName: "Amir",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Amir Personalized Coloring Experience",
variantId: "50126002389229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amir_final_cover.png?v=1781929666",
price: "$14.99",
preorder: true
},
{
title: "Amir Dragon Holographic Sticker",
variantId: "50127064105197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amirstickerwebsite.png?v=1781967114",
price: "$4.99",
preorder: false
},
{
title: "Amir Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Arthur-boy": {
displayName: "Arthur",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Arthur Personalized Coloring Experience",
variantId: "50126127202541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Arthur_final_cover.png?v=1781929666",
price: "$14.99",
preorder: true
},
{
title: "Arthur Dragon Holographic Sticker",
variantId: "50127065710829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Arthurstickerwebsite.png?v=1781967222",
price: "$4.99",
preorder: false
},
{
title: "Arthur Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Ace-boy": {
displayName: "Ace",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ace Personalized Coloring Experience",
variantId: "50127716253933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Acefinalcover.png?v=1781988445",
price: "$14.99",
preorder: true
},
{
title: "Ace Dragon Holographic Sticker",
variantId: "50127682961645",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Acewebsitesticker.png?v=1781987549",
price: "$4.99",
preorder: false
},
{
title: "Ace Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Ashton-boy": {
displayName: "Ashton",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ashton Personalized Coloring Experience",
variantId: "50127687221485",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ashtonfinalcover.png?v=1781987763",
price: "$14.99",
preorder: true
},
{
title: "Ashton Dragon Holographic Sticker",
variantId: "50127665692909",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ashton_website_sticker.png?v=1781986784",
price: "$4.99",
preorder: false
},
{
title: "Ashton Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Atlas-boy": {
displayName: "Atlas",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Atlas Personalized Coloring Experience",
variantId: "50126045217005",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Atlas_final_cover.png?v=1781929666",
price: "$14.99",
preorder: true
},
{
title: "Atlas Dragon Holographic Sticker",
variantId: "50127066857709",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Atlasstickerwebsite.png?v=1781967309",
price: "$4.99",
preorder: false
},
{
title: "Atlas Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Amari-boy": {
displayName: "Amari",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Amari Personalized Coloring Experience",
variantId: "50180860903661",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amari_final_cover.png?v=1782611298",
price: "$14.99",
preorder: true
},
{
title: "Amari Dragon Holographic Sticker",
variantId: "50180836589805",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amariwebsitesticker.png?v=1782611023",
price: "$4.99",
preorder: false
},
{
title: "Amari Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Amira-girl": {
displayName: "Amira",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Amira Personalized Coloring Experience",
variantId: "50274177548525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amira_final_cover.png?v=1783795016",
price: "$14.99",
preorder: true
},
{
title: "Amira Unicorn Holographic Sticker",
variantId: "50274688073965",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Amiraholographicsticker_68fa2899-e98c-4e4b-8042-dc591ec547bf.png?v=1783832209",
price: "$4.99",
preorder: false
},
{
title: "Amira Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Ariella-girl": {
displayName: "Ariella",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ariella Personalized Coloring Experience",
variantId: "50274166931693",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ariella_final_cover.png?v=1783795017",
price: "$14.99",
preorder: true
},
{
title: "Ariella Unicorn Holographic Sticker",
variantId: "50274690498797",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ariellaholographicsticker.png?v=1783828739",
price: "$4.99",
preorder: false
},
{
title: "Ariella Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Adalyn-girl": {
displayName: "Adalyn",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Adalyn Personalized Coloring Experience",
variantId: "50274160247021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adalyn_final_cover.png?v=1783795017",
price: "$14.99",
preorder: true
},
{
title: "Adalyn Unicorn Holographic Sticker",
variantId: "50274677522669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adalyn_holographic_sticker.png?v=1783828002",
price: "$4.99",
preorder: false
},
{
title: "Adalyn Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Alana-girl": {
displayName: "Alana",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alana Personalized Coloring Experience",
variantId: "50274165915885",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alana_final_cover.png?v=1783795017",
price: "$14.99",
preorder: true
},
{
title: "Alana Unicorn Holographic Sticker",
variantId: "50274700001517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alanaholographicsticker.png?v=1783829304",
price: "$4.99",
preorder: false
},
{
title: "Alana Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Alani-girl": {
displayName: "Alani",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alani Personalized Coloring Experience",
variantId: "50305424359661",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alanifinalcover.png?v=1784424711",
price: "$14.99",
preorder: true
},
{
title: "Alani Unicorn Holographic Sticker",
variantId: "50305509687533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alani_holographic_sticker.png?v=1784431196",
price: "$4.99",
preorder: false
},
{
title: "Alani Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Adonis-boy": {
displayName: "Adonis",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Adonis Personalized Coloring Experience",
variantId: "50399405965549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adonis_final_cover.png?v=1784947223",
price: "$14.99",
preorder: true
},
{
title: "Adonis Dragon Holographic Sticker",
variantId: "50399529697517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adonis_holographic_sticker.png?v=1784945962",
price: "$4.99",
preorder: false
},
{
title: "Adonis Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Avery-boy": {
displayName: "Avery",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Avery Personalized Coloring Experience",
variantId: "50399383978221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Avery_final_cover_b7e8c604-1578-4a71-bc86-ce3e28c100ce.png?v=1784947223",
price: "$14.99",
preorder: true
},
{
title: "Avery Dragon Holographic Sticker",
variantId: "50399547195629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Avery_boy_holographic_sticker.png?v=1784945963",
price: "$4.99",
preorder: false
},
{
title: "Avery Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Alaina-girl": {
displayName: "Alaina",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Alaina Personalized Coloring Experience",
variantId: "50519260037357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alaina_final_cover.png?v=1786941539",
price: "$14.99",
preorder: true
},
{
title: "Alaina Unicorn Holographic Sticker",
variantId: "50497541341421",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Alaina_holographic_sticker.png?v=1787505458",
price: "$4.99",
preorder: false
},
{
title: "Alaina Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Ailany-girl": {
displayName: "Ailany",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Ailany Personalized Coloring Experience",
variantId: "50519263903981",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ailany_final_cover.png?v=1786941539",
price: "$14.99",
preorder: true
},
{
title: "Ailany Unicorn Holographic Sticker",
variantId: "50497542193389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Ailany_holographic_sticker.png?v=1787505458",
price: "$4.99",
preorder: false
},
{
title: "Ailany Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Annie-girl": {
displayName: "Annie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Annie Personalized Coloring Experience",
variantId: "50595068018925",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Anniefinalcover.png?v=1788159256",
price: "$14.99",
preorder: true
},
{
title: "Annie Unicorn Holographic Sticker",
variantId: "50604073943277",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Annie_holographic_sticker.png?v=1788224572",
price: "$4.99",
preorder: false
},
{
title: "Annie Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Aspen-girl": {
displayName: "Aspen",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Aspen Personalized Coloring Experience",
variantId: "50594961326317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aspenfinalcover.png?v=1788158165",
price: "$14.99",
preorder: true
},
{
title: "Aspen Unicorn Holographic Sticker",
variantId: "50604074664173",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Aspen_holographic_sticker.png?v=1788224571",
price: "$4.99",
preorder: false
},
{
title: "Aspen Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Adaline-girl": {
displayName: "Adaline",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Adaline Personalized Coloring Experience",
variantId: "50595116286189",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adalinefinalcover.png?v=1788159738",
price: "$14.99",
preorder: true
},
{
title: "Adaline Unicorn Holographic Sticker",
variantId: "50604076433645",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Adaline_holographic_sticker.png?v=1788224572",
price: "$4.99",
preorder: false
},
{
title: "Adaline Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 










};